import { render, staticRenderFns } from "./PriceEditDialog.vue?vue&type=template&id=1a637b4c&scoped=true"
import script from "./PriceEditDialog.vue?vue&type=script&lang=ts"
export * from "./PriceEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./PriceEditDialog.vue?vue&type=style&index=0&id=1a637b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a637b4c",
  null
  
)

export default component.exports